import { PortalPair } from '../../../utils/portal-pair';
import { SidebarButtonsIcons } from './constants';

export const CheckDoublePortal = new PortalPair(SidebarButtonsIcons.CHECK_DOUBLE);
export const ListCheckPortal = new PortalPair(SidebarButtonsIcons.LIST_CHECK);
